import React from "react";
import { iconProps } from "../../../../Helper";

export const ImageToPromptIcon = ({ className }: iconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
    >
      <g clip-path="url(#clip0_14046_122858)">
        <line
          x1="0.5"
          y1="0.5"
          x2="3.5"
          y2="0.5"
          className={`${className}-stroke`}
        />
        <line x1="1" y1="3" x2="1" className={`${className}-stroke`} />
        <line
          y1="-0.5"
          x2="3"
          y2="-0.5"
          transform="matrix(-1 0 0 1 16.5 1)"
          className={`${className}-stroke`}
        />
        <line
          y1="-0.5"
          x2="3"
          y2="-0.5"
          transform="matrix(0 -1 -1 0 15.5 3)"
          className={`${className}-stroke`}
        />
        <line
          y1="-0.5"
          x2="3"
          y2="-0.5"
          transform="matrix(1 0 0 -1 0.5 15)"
          className={`${className}-stroke`}
        />
        <line
          y1="-0.5"
          x2="3"
          y2="-0.5"
          transform="matrix(0 1 1 0 1.5 13)"
          className={`${className}-stroke`}
        />
        <line
          x1="16.5"
          y1="15.5"
          x2="13.5"
          y2="15.5"
          className={`${className}-stroke`}
        />
        <line
          x1="16"
          y1="13"
          x2="16"
          y2="16"
          className={`${className}-stroke`}
        />
        <path
          d="M4.16972 13.5C3.84285 13.5 3.56618 13.3868 3.33971 13.1603C3.11324 12.9338 3 12.6572 3 12.3303V3.66972C3 3.34285 3.11324 3.06618 3.33971 2.83971C3.56618 2.61324 3.84285 2.5 4.16972 2.5H12.8303C13.1572 2.5 13.4338 2.61324 13.6603 2.83971C13.8868 3.06618 14 3.34285 14 3.66972V12.3303C14 12.6572 13.8868 12.9338 13.6603 13.1603C13.4338 13.3868 13.1572 13.5 12.8303 13.5H4.16972ZM4.16972 12.5294H12.8303C12.8801 12.5294 12.9257 12.5087 12.9671 12.4671C13.0087 12.4257 13.0294 12.3801 13.0294 12.3303V3.66972C13.0294 3.6199 13.0087 3.57428 12.9671 3.53287C12.9257 3.49135 12.8801 3.47059 12.8303 3.47059H4.16972C4.1199 3.47059 4.07428 3.49135 4.03287 3.53287C3.99135 3.57428 3.97059 3.6199 3.97059 3.66972V12.3303C3.97059 12.3801 3.99135 12.4257 4.03287 12.4671C4.07428 12.5087 4.1199 12.5294 4.16972 12.5294ZM5.10294 11.0735H11.9467L9.81903 8.2365L8.00225 10.6007L6.70813 8.94568L5.10294 11.0735Z"
          className={className}
        />
      </g>
      <defs>
        <clipPath id="clip0_14046_122858">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
